import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/medical/get-medical-staff';

  return await API({ endpoint });
}
